const examRoutes = [
  {
    path: "/exam",
    name: "ExamHome",
    component: () => import("../components/exam/ExamHome.vue"),
    meta: {
      icon: "mdi-school",
      localize: "exam.common.home",
      requiresAuth: true
    }
  },
  {
    path: "/exam/exam/:id",
    name: "ExamTake",
    component: () => import("../components/exam/ExamPage.vue"),
    meta: {
      icon: "mdi-clipboard-text",
      localize: "exam.common.exam",
      requiresAuth: true
    },
    props: true
  },
  {
    path: "/exam/admin",
    name: "ExamAdmin",
    component: () => import("../components/exam/ExamAdmin.vue"),
    meta: {
      icon: "mdi-cog",
      localize: "exam.common.admin",
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: "/exam/admin/create",
    name: "ExamCreate",
    component: () => import("../components/exam/ExamCreate.vue"),
    meta: {
      icon: "mdi-plus-circle",
      localize: "exam.createExam.title",
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: "/exam/admin/edit/:id",
    name: "ExamEdit",
    component: () => import("../components/exam/ExamEdit.vue"),
    meta: {
      icon: "mdi-pencil",
      localize: "exam.editExam.title",
      requiresAuth: true,
      requiresAdmin: true
    },
    props: true
  },
  {
    path: "/exam/results/:examResultId?",
    name: "ExamResults",
    component: () => import("../components/exam/ExamResults.vue"),
    meta: {
      icon: "mdi-chart-box",
      localize: "exam.common.results",
      requiresAuth: true
    },
    props: true
  }
];

export default examRoutes;

